// extracted by mini-css-extract-plugin
export const navItem = "NavItem-module--nav-item--GgNZv";
export const navItemPrimary = "NavItem-module--nav-item-primary--1ko89";
export const navItemSecondary = "NavItem-module--nav-item-secondary--J1VIA";
export const navItemExpandOnMobile = "NavItem-module--nav-item-expand-on-mobile--2h1B4";